export const ROUTE_LOGIN = '/login'
export const ROUTE_WELCOME = '/welcome'
export const ROUTE_LOCATIONS = '/locations'
export const ROUTE_PROFILE = '/profile'
export const ROUTE_ROOT = '/'
export const SUPABASE_AUTH_LOCAL_STORAGE_KEY = 'supabase.auth.token'
export const SUPABASE_AUTH_COOKIE_KEY = 'sb:token'
